'use client'
import { useI18N } from '@/context/I18NContext'
import type { Language } from '@carbonara/translations'

const intls = {
	nb: (options?: Intl.NumberFormatOptions) =>
		new Intl.NumberFormat('nb-NO', options),
	en: (options?: Intl.NumberFormatOptions) =>
		new Intl.NumberFormat('en-US', options),
}

export const formatNumber = (
	num: number | bigint,
	options: Intl.NumberFormatOptions = {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	},
	language: Language = 'nb',
) => {
	const intl = (intls[language] || intls.nb)(options)

	return intl.format(num)
}

interface Props {
	num: number
	options?: Intl.NumberFormatOptions
}

export const FormattedNumber: React.FC<Props> = ({ num, options }) => {
	const { language } = useI18N()

	const formatted = formatNumber(num, options, language)

	return <>{formatted}</>
}
